import React , {useState , useEffect} from 'react';
import { fetchTotalRentalUnverifiedCars } from '../../stores/api_calls/dashboard';
import {MdCarRental} from 'react-icons/md'
import {AiOutlineArrowRight} from 'react-icons/ai'
import './card.scss'
import { useNavigate } from 'react-router-dom';

const RentalUnverified = () => {

    const navigate = useNavigate()
    const [activeCars , setActiveCars] = useState()
    const [isLoading , setIsLoading] = useState(false)

    useEffect(()=>{
        setIsLoading(true)
        const getActiveCars = fetchTotalRentalUnverifiedCars()

        getActiveCars.then((res)=>{
            if(res.data){
                if(res.data.success){
                    setActiveCars(res.data.data)
                    setIsLoading(false)
                }
            }
        }).catch((e)=>{
            console.log(e)
        })
    },[])

    return (
        <div>
            <div className='rental-unverified header-card'>
                <p className='header-text'>Rental <br/> Unverified Bikes</p>
                <MdCarRental style={{width:"80px" , height:"80px"}}/>
            </div>
            <div className='rental-unverified body-card'>
                <p className='active-text'>Total : {isLoading ? 'fetching' : !isLoading&&activeCars? activeCars.total_rental : 0}</p>
                <div className='goIcon' onClick={()=>navigate("../rentals/unverified", { replace: true })}>
                    <AiOutlineArrowRight/>
                </div>
            </div>
        </div>
    )
}

export default RentalUnverified
